'use client'

import Select from '@dg/common/components/Select/Select'

export default Select
